import { render, staticRenderFns } from "./resetPasswordMember.vue?vue&type=template&id=30cf9fd4&lang=pug"
import script from "./resetPasswordMember.vue?vue&type=script&lang=js"
export * from "./resetPasswordMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports